import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Tag, Typography } from "antd";
import { ReleaseNoteType } from "../../../../Interface";
import { WEB_RELEASE_NOTES_VERSIONS } from "../../../ReleaseNotesDetail/releaseNotesContent";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

interface ReleaseNoteCardProps {
  releaseNote: ReleaseNoteType;
}

const ReleaseNoteCard: React.FC<ReleaseNoteCardProps> = ({ releaseNote }) => {
  const navigate = useNavigate();
  const formattedDate = dayjs(releaseNote.date).fromNow();

  const hasWebVersion = WEB_RELEASE_NOTES_VERSIONS.includes(releaseNote.version);

  const handleSeeFullDetails = () => {
    // If this version has a web-based release notes page, navigate to it
    if (hasWebVersion) {
      navigate(`/release-notes/${releaseNote.version}`);
      return;
    }
    
    // Otherwise, open the PDF document link
    if (!releaseNote.documentLink) {
      return;
    }
    window.open(releaseNote.documentLink, "_blank");
  };

  const getTagColor = () => {
    if (releaseNote.status === "current") {
      return "#87d068";
    }
    if (releaseNote.status === "upcoming") {
      return "#2d8cf0";
    }
    return "#f50";
  };

  return (
    <div className="release-note-card">
      <Typography.Title level={5} style={{ margin: 0 }}>
        Version {releaseNote.version}
      </Typography.Title>
      <div className="release-note-card-tags">
        <Tag color={getTagColor()}>
          <strong>{releaseNote.status.toUpperCase()}</strong>
        </Tag>
        <Typography.Text type="secondary"> {formattedDate}</Typography.Text>
      </div>

      <Typography.Paragraph style={{ margin: 0 }}>
        {releaseNote.description}
      </Typography.Paragraph>

      {(releaseNote.documentLink || hasWebVersion) && (
        <div className="release-note-card-actions">
          <Button onClick={handleSeeFullDetails}>See Full Details</Button>
        </div>
      )}
    </div>
  );
};

export default ReleaseNoteCard;
